import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../store/authStore';
import { logout as apiLogout } from '../../api/auth';
import { LogOut, User, Globe } from 'lucide-react';

export default function Header() {
  const { t, i18n } = useTranslation();
  const { user, logout } = useAuthStore();

  const handleLogout = async () => {
    try {
      await apiLogout();
    } catch {
      // Continue with logout even if API fails
    }
    logout();
  };

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'he' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <header className="flex h-16 items-center justify-between border-b bg-white px-6">
      <div className="flex items-center gap-4">
        <h1 className="text-xl font-semibold text-gray-900">
          Social Media Insights
        </h1>
      </div>

      <div className="flex items-center gap-4">
        {/* Language Toggle */}
        <button
          onClick={toggleLanguage}
          className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-gray-600 hover:bg-gray-100"
        >
          <Globe className="h-4 w-4" />
          <span>{i18n.language === 'en' ? 'עברית' : 'English'}</span>
        </button>

        {/* User Menu */}
        <div className="flex items-center gap-3 border-l pl-4">
          <div className="flex items-center gap-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary text-white">
              <User className="h-4 w-4" />
            </div>
            <span className="text-sm font-medium text-gray-700">
              {user?.name || 'User'}
            </span>
          </div>

          <button
            onClick={handleLogout}
            className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-gray-600 hover:bg-gray-100"
            title={t('auth.logout')}
          >
            <LogOut className="h-4 w-4" />
          </button>
        </div>
      </div>
    </header>
  );
}
